import { DATABASE_UPDATE } from "../actions/database";
import buildReducer from "./build-reducer";
import databaseRowsToIdMap from "../database-rows-to-id-map";
import { Map } from "immutable";
import { REMOVE_TOURNAMENT, TOURNAMENT_ENTER_ERROR, TOURNAMENT_ENTERING, TOURNAMENT_ENTERED } from "../actions/tournament";

let reducers = {};

reducers[DATABASE_UPDATE] = (state, { tables: { tournaments } }) => {
  if (tournaments === undefined) {
    return state;
  }

  return state.mergeDeep(databaseRowsToIdMap(tournaments));
};
reducers[TOURNAMENT_ENTER_ERROR] = (state, { tournamentId, error }) => {
  return state.deleteIn([tournamentId, "entering"]).setIn([tournamentId, "enterError"], error);
};
reducers[TOURNAMENT_ENTERED] = (state, { tournamentId }) => {
  return state.deleteIn([tournamentId, "entering"]).deleteIn([tournamentId, "enterError"]);
};
reducers[TOURNAMENT_ENTERING] = (state, { tournamentId }) => {
  return state.setIn([tournamentId, "entering"], true);
};
reducers[REMOVE_TOURNAMENT] = (state, { tables: { tournaments } }) => {
  var toRemove = tournaments.map(t => t.id);
  return state.filter(tournament => !toRemove.includes(tournament.get("id")));
};

export default buildReducer(Map(), reducers);
